/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thiswillmaketheeventvisibletoallusers8Inputs */

const en_thiswillmaketheeventvisibletoallusers8 = /** @type {(inputs: Thiswillmaketheeventvisibletoallusers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will make the event visible to all users.`)
};

const de_thiswillmaketheeventvisibletoallusers8 = /** @type {(inputs: Thiswillmaketheeventvisibletoallusers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dann sehen alle das Event.`)
};

/**
* | output |
* | --- |
* | "This will make the event visible to all users." |
*
* @param {Thiswillmaketheeventvisibletoallusers8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thiswillmaketheeventvisibletoallusers8 = /** @type {((inputs?: Thiswillmaketheeventvisibletoallusers8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thiswillmaketheeventvisibletoallusers8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thiswillmaketheeventvisibletoallusers8(inputs)
	return de_thiswillmaketheeventvisibletoallusers8(inputs)
});
export { thiswillmaketheeventvisibletoallusers8 as "thisWillMakeTheEventVisibleToAllUsers" }